<script>
    import { onMount } from "svelte";
    import PotionCard from "./PotionCard.svelte"; // Assuming PotionCard is a component you use
    import { SPRITES } from "../../constants/sprites"; // Assuming you have SPRITES
    import { SetupStore } from "../stores/gameStore";
    import { Top3Potions } from "../stores/gameStore";
  
    export let width
    $: scale = width / SPRITES["PLAYERBOARD"].width;

    $: potionsOrder = $Top3Potions; // This will keep the order of potions
  
    // Function to handle drag start
    function handleDragStart(e, index) {
      e.dataTransfer.setData("potionIndex", index); // Set index as data to drag
    }
  
    // Function to handle drop
    function handleDrop(e, dropIndex) {
      const draggedIndex = e.dataTransfer.getData("potionIndex");
      swapPotions(draggedIndex, dropIndex);
    }
  
    // Function to swap potions in the array
    function swapPotions(fromIndex, toIndex) {
      const newOrder = [...potionsOrder];
      const temp = newOrder[fromIndex];
      newOrder[fromIndex] = newOrder[toIndex];
      newOrder[toIndex] = temp;
      potionsOrder = newOrder; // Update the order
    }
  
    // Function to send the final order when "Finished" is clicked
    function handleFinish() {
        window.GAME.bgaPerformAction("alchemistSkillViewPile", {
            cardId01: potionsOrder[0],
            cardId02: potionsOrder[1],
            cardId03: potionsOrder[2]
        });
    }

    let selectedCard = null;
    function handleClick(potionId) {
      if (potionId === selectedCard) {
        selectedCard = null;
        return;
      }
      if (selectedCard === null) {
        selectedCard = potionId;
        return;
      }
      swapPotions(potionsOrder.indexOf(selectedCard), potionsOrder.indexOf(potionId));
      selectedCard = null;
    }

    const textFinished = _('Finished');
  </script>

  <div class="potions-container">
    {#each potionsOrder as potionId, i}
      <!-- svelte-ignore a11y-no-static-element-interactions -->
      <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
          class="potion-slot"
          draggable="true"
          on:dragstart={(e) => handleDragStart(e, i)}
          on:dragover={(e) => e.preventDefault()}
          on:drop={(e) => handleDrop(e, i)}
        >
          <div class="label">{i === 0 ? "1." : i === 1 ? "2." : "3."}</div>

          <div
            class="card"
            on:click={handleClick(potionId)}
          >
            <div
            class={potionId === selectedCard ? "decide-white" : ""}
            >
              <PotionCard
                width={SPRITES["ITEMS_FRONT"].width * scale * 0.5}
                card={$SetupStore.data.cards[potionId]}
                active={false}
                id={potionId}
              />
            </div>
          </div>
        </div>
    {/each}
  </div>
  
  <button
    class="btn"
    on:click={handleFinish}
    >{textFinished}
    </button>
  
  <style>
    .potions-container {
      display: flex;
      justify-content: space-between;
      gap: 1rem;
    }
  
    .potion-slot {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  
    .label {
      margin-bottom: 0.5rem;
      font-weight: bold;
    }
    .card:hover {
      filter: brightness(1.2);
    }

    .decide-white {
      outline: 2px solid white;
      outline-offset: 2px;
      pointer-events: none;
    }

  </style>
  